import { getCurrentRadioValue, onCheckboxValueChange } from "./_utils"

const locationField = document.getElementById("locationField")

function executeWhenDivisionItemsAvailable(currentItem, callback) {
    if (currentItem && currentItem.divisionItems) {
        callback(currentItem)
    } else {
        const onDivisionItemsAvailable = (evt) => {
            const item = evt.detail.currentItem
            if (item === currentItem) {
                callback(item)
                locationField.removeEventListener(
                    "divisionItemsAvailable",
                    onDivisionItemsAvailable
                )
            }
        }
        locationField.addEventListener(
            "divisionItemsAvailable",
            onDivisionItemsAvailable
        )
    }
}

const setCurrentOrderType = (orderType) => {
    if (orderType == undefined) return

    const currentItem = location.currentItem
    executeWhenDivisionItemsAvailable(currentItem, (currentItem) => {
        refreshAvailableDivisions(currentItem, orderType)
    })
}

onCheckboxValueChange("CurrentOrderType", (orderType) => {
    setCurrentOrderType(orderType)
})

function changeDivisionState(sDivision, bState) {
    const template = document.querySelector(`#template-${sDivision}`)
    const container = document.querySelector(`#formGroup-${sDivision}`)

    if (bState) {
        const content = template.content
        container.replaceChildren(content)
        container.classList.add("show")

        setCurrentOrderType(getCurrentRadioValue("CurrentOrderType"))
    } else {
        container.classList.remove("show")
        template.content.replaceChildren(...container.children)
    }
}

/**
 *  Iteriates over all division Checkboxes
 * @param {Element} referenceItem The anchor element (document or DOM ELement)
 * @param {(element: Element, division: string)=>void} callback Callback for each element
 */
function iterateDivisionCheckboxes(referenceItem, callback) {
    const divisionElements = referenceItem.querySelectorAll(`[data-division]`)
    for (const element of divisionElements) {
        const division = element.dataset.division
        callback(element, division)
    }
}

const tuebingenArea = ["72070", "72072", "72074", "72076"]

function refreshAvailableDivisions(currentLocationItem, currentOrderType) {
    const hasDivision = (division) =>
        currentLocationItem.divisionItems.findIndex(
            (d) => d.division == division && d.orderType == currentOrderType
        ) != -1

    iterateDivisionCheckboxes(document, (element, division) => {
        const available = hasDivision(division)
        const isWater = division === "40"
        const inTuebingen = tuebingenArea.some((sub) =>
            locationField.value.includes(sub)
        )

        if (!available && (!isWater || !inTuebingen)) {
            if (element.checked) {
                element.checked = false
                changeDivisionState(division, false)
            }
            element.disabled = true
        } else if (available) {
            element.disabled = false
        }
    })
}

function initializeDivisionCheckboxes(referenceItem) {
    iterateDivisionCheckboxes(referenceItem, (element, division) => {
        element.addEventListener("change", (e) => {
            changeDivisionState(division, e.currentTarget.checked)
        })

        if (element.checked) {
            changeDivisionState(division, true)
        }
    })
}

initializeDivisionCheckboxes(document)

// For Tübingen => we need to initialize this when the conditional area changes
const conditionalArea = document.querySelector(
    `[data-conditional-area="CurrentOrderType"]`
)
if (conditionalArea != null) {
    conditionalArea.addEventListener("changeContent", (e) => {
        initializeDivisionCheckboxes(e.currentTarget)
    })
}

locationField.addEventListener("itemSelected", (evt) => {
    const currentItem = evt.detail.item
    const currentOrderType = getCurrentRadioValue("CurrentOrderType") ?? ""
    executeWhenDivisionItemsAvailable(currentItem, (currentItem) => {
        refreshAvailableDivisions(currentItem, currentOrderType)
    })
})

for (let row of document.getElementsByClassName("product-row")) {
    row.addEventListener("click", (e) => {
        const checkbox = e.currentTarget.querySelector(".form-check-input")
        checkbox.click()
    })
}
